/* Heavy Hug: countdowns to the real delivery cutoff.
   Markup: <div data-hh-countdown="2026-12-01T23:59:00+10:00">
             <span data-hh-before> ... [data-d] [data-h] [data-m] [data-s] ... </span>
             <span data-hh-after> shown once the date has passed </span>
           </div> */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick(el, end) {
    var left = end - Date.now();
    if (left <= 0) {
      el.classList.add('is-past');
      return false;
    }
    var s = Math.floor(left / 1000);
    var parts = {
      d: Math.floor(s / 86400),
      h: Math.floor((s % 86400) / 3600),
      m: Math.floor((s % 3600) / 60),
      s: s % 60
    };
    Object.keys(parts).forEach(function (k) {
      el.querySelectorAll('[data-' + k + ']').forEach(function (n) {
        n.textContent = k === 'd' ? parts[k] : pad(parts[k]);
      });
    });
    return true;
  }

  function init(root) {
    (root || document).querySelectorAll('[data-hh-countdown]').forEach(function (el) {
      if (el.__hh) return;
      el.__hh = true;
      var end = Date.parse(el.getAttribute('data-hh-countdown'));
      if (isNaN(end)) return;
      if (!tick(el, end)) return;
      var t = setInterval(function () { if (!tick(el, end)) clearInterval(t); }, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  // theme editor re-renders sections
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
